/* eslint-disable import/prefer-default-export */

export const GET_LOGISTICS_INFO = "GET_LOGISTICS_INFO";
export const GET_LOGISTICS_INFO_ERROR = "GET_LOGISTICS_INFO_ERROR";
